import { render, staticRenderFns } from "./awerack-root.html?vue&type=template&id=2a060390&scoped=true&external"
import script from "./awerack-root.js?vue&type=script&lang=js&external"
export * from "./awerack-root.js?vue&type=script&lang=js&external"
import style0 from "./awerack-root.scss?vue&type=style&index=0&id=2a060390&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a060390",
  null
  
)

export default component.exports